import React, { useEffect, useState } from "react";
import { AlertCircle, ChevronDown, ChevronUp } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { apiClient } from "../../lib/apiClient";
import { MoveDeliveryDialog } from "./MoveDeliveryDialog";

export function UnassignedDeliveriesPanel({ date }) {
  const [state, setState] = useState({ loading: true, total: 0, items: [] });
  const [expanded, setExpanded] = useState(false);
  const [moving, setMoving] = useState(null);

  const load = React.useCallback(() => {
    setState((s) => ({ ...s, loading: true }));
    apiClient.get("/deliveries", { params: { date: date || undefined, unassigned: true, exclude_pickup: true, limit: 50 } })
      .then(({ data }) => setState({ loading: false, total: data.total, items: data.items }))
      .catch(() => setState({ loading: false, total: 0, items: [] }));
  }, [date]);

  useEffect(() => { load(); }, [load]);

  if (state.loading) return null;

  if (state.total === 0) {
    return <p className="mb-4 text-xs text-text-muted" data-testid="unassigned-deliveries-clean">No unassigned deliveries{date ? ` for ${date}` : ""}.</p>;
  }

  return (
    <div className="mb-4 rounded-md border border-accent/40 bg-accent/10 p-3" data-testid="unassigned-deliveries-panel">
      <button type="button" onClick={() => setExpanded((e) => !e)} className="flex w-full items-center justify-between text-sm font-medium text-primary" data-testid="unassigned-deliveries-toggle">
        <span className="flex items-center gap-2"><AlertCircle size={15} strokeWidth={1.5} /> {state.total} unassigned deliveries{date ? ` for ${date}` : ""}</span>
        {expanded ? <ChevronUp size={15} strokeWidth={1.5} /> : <ChevronDown size={15} strokeWidth={1.5} />}
      </button>
      {expanded && (
        <div className="mt-3 max-h-52 space-y-1 overflow-y-auto" data-testid="unassigned-deliveries-list">
          {state.items.map((d) => (
            <div key={d.id} className="flex items-center justify-between rounded-sm bg-surface px-2 py-1.5 text-xs">
              <span className="truncate">
                #{d.id} — <Link to={`/customers/${d.customer_id}`} className="text-primary hover:underline">{d.customer_name || `#${d.customer_id}`}</Link>
                {" · "}{d.plan_name || "—"}
              </span>
              <Button variant="outline" size="sm" onClick={() => setMoving(d)} data-testid={`unassigned-move-button-${d.id}`}>
                Assign to Route
              </Button>
            </div>
          ))}
          {state.total > state.items.length && <p className="text-xs text-text-muted">+ {state.total - state.items.length} more</p>}
        </div>
      )}
      <MoveDeliveryDialog
        open={!!moving} onOpenChange={(v) => !v && setMoving(null)}
        delivery={moving} currentRouteId={null} date={date}
        onDone={() => { setMoving(null); load(); }}
      />
    </div>
  );
}
